export default "__VITE_ASSET__DdMm9MJ9__"